import { useMemo } from 'react'
import { AcDataGrid } from '@components'
import { DataGridStore } from 'src/stores/datagrid.stores'
import { useStore } from '@hooks/use-store'
import { ROUTE_PATHS, STORE_KEYS } from '@constants'

export const SystemFailedJobsTab = () => {
  const store = useStore()
  const dataGridStore = useMemo(() => new DataGridStore(store, STORE_KEYS.SYSTEM_FAILED_JOBS), [store])

  return (
    <div style={{ marginTop: 24, marginBottom: 12 }}>
      <AcDataGrid store={dataGridStore} detailPath={ROUTE_PATHS.APP_FAILED_JOB_DETAIL} />
    </div>
  )
}
